import { GroupBox } from 'react95';
import { useLocale } from '../i18n/LocaleContext';
import { Block, SectionTitle } from './ui';

const Education = ({ data }) => {
  const { t } = useLocale();
  const labels = t.education;

  return (
    <>
      <SectionTitle>{labels.title}</SectionTitle>
      {data.education.map((edu) => (
        <Block key={`${edu.institution}-${edu.years}`}>
          <GroupBox label={edu.institution}>
            <p>
              <strong>{labels.degree}:</strong> {edu.degree}
            </p>
            <p>
              <strong>{labels.years}:</strong> {edu.years}
            </p>
          </GroupBox>
        </Block>
      ))}
    </>
  );
};

export default Education;
